import { useDrawerContext } from './useDrawerContext';

export function useDrawerController() {
    const { drawerController } = useDrawerContext();

    return drawerController;
}
